
























import InputField from "./InputField";
import Multiselect from "vue-multiselect";
import { Config } from "../../utils/Config";
import { RecurrenceIntervention } from "../../models/RecurrenceIntervention";
import { RecurrenceInterventionApi } from "../../api/RecurrenceInterventionApi";

export default {
    name: "RecurrenceInterventionSelect",
    components: { InputField, Multiselect },
    props: {
        label: String,
    },
    data() {
        return {
            RecurrenceInterventionApi: new RecurrenceInterventionApi(),
            selected: null,
            options: [],
            vueMultiselectParams: Config.vueMultiselectParams,
            isLoading: false,
        };
    },
    created() {
        let self = this;
    },
    methods: {
        getInterventions: function (value) {
            let self = this;
            self.isLoading = true;
            self.RecurrenceInterventionApi.getAll({
                limit: 50,
                search: value,
            }).then(function (res) {
                self.options = res.data;
                self.isLoading = false;
            });
        },
    },
    watch: {
        selected: function () {
            this.$emit("input", this.selected);
        },
    },
};
